import React from "react";
import BookingTicket from "./components/ConfirmationStep/BookingTicket";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import LoaderOverlay from "../../layout/components/LoaderOverlay";
import { useTranslation } from "react-i18next";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { Button } from "../../../components/ui/button";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";

interface ConfirmationStepProps {
  onAddAnotherEquipment: () => void;
  reservationError?: boolean;
  onRetry?: () => void;
}

function ConfirmationStep({ onAddAnotherEquipment, reservationError, onRetry }: ConfirmationStepProps) {
  const { t } = useTranslation();
  const reservations = useSelector((state: RootState) => state.bookingCreation.reservations)!;
  const location = useSelector((state: RootState) => state.bookingCreation.selectedLocation)!;
  const isLoading = !(location && reservations.length > 0);

  if (reservationError) {
    return (
      <div
        role="alert"
        aria-live="assertive"
        className="flex flex-col items-center justify-center py-12 px-6"
      >
        <div className="max-w-md w-full space-y-6">
          <div className="flex justify-center">
            <div className="bg-red-100 rounded-full p-4">
              <AlertCircle className="h-12 w-12 text-red-600" />
            </div>
          </div>
          <div className="text-center space-y-2">
            <h2 className="text-2xl font-bold text-slate-900">
              {t("book_location.error.create_reservation")}
            </h2>
            <p className="text-slate-600">
              {t("common.please_try_again")}
            </p>
          </div>
          {onRetry && (
            <Button
              onClick={onRetry}
              variant="outline"
              className="w-full"
              size="lg"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              {t("book_location.go_back")}
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <LoaderOverlay open={isLoading} />
      ) : (
        <div className="flex flex-col justify-between h-full">
          <div className="overflow-auto flex-grow">
            <BookingTicket location={location.name} reservations={reservations} amount={1} />
          </div>
          <div className="text-center text-black text-xl font-semibold mb-8">
            <button
              onClick={onAddAnotherEquipment}
              className="underline bg-transparent border-none cursor-pointer"
            >
              {t("book_location.confirmation.add_another_sup")}
            </button>
          </div>
          <SoftSignupPrompt />
        </div>
      )}
      {/*
      <Box>
        {enableCouponDialog && (
          <StyledCouponWrapper>
            <Button
              variant={'contained'}
              size={'small'}
              color={'secondary'}
              onClick={() => setCouponDialogOpen(true)}
              children={t('book_location.confirmation.redeem_coupon')}
            />
            <RedeemCouponDialog
              open={couponDialogOpen}
              onClose={() => setCouponDialogOpen(false)}
            />
          </StyledCouponWrapper>
        )}

      </Box> */}
    </>
  );
}

export default ConfirmationStep;
